import React, { useState, useMemo } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import 'yet-another-react-lightbox/styles.css';
import { getAttachmentKind } from './attachmentKind';

const TalkAttachmentImageViewerModal = ({ upload, messageUploads = [], onClose }) => {
    const imageUploads = useMemo(
        () => (messageUploads.length > 0 ? messageUploads : (upload ? [upload] : []))
            .filter((u) => getAttachmentKind(u.name) === 'image'),
        [messageUploads, upload]
    );

    const initialIndex = useMemo(() => {
        const idx = imageUploads.findIndex((u) => u.id === upload?.id);
        return idx >= 0 ? idx : 0;
    }, [imageUploads, upload]);

    const [currentIndex, setCurrentIndex] = useState(initialIndex);

    if (imageUploads.length === 0) return null;

    const slides = imageUploads.map((u) => ({ src: u.url, title: u.name, alt: u.name }));

    return (
        <Lightbox
            open={true}
            close={onClose}
            slides={slides}
            index={currentIndex}
            on={{ view: ({ index }) => setCurrentIndex(index) }}
            plugins={[Zoom]}
            animation={{ fade: 250, swipe: 250 }}
            carousel={{ finite: true }}
            controller={{ closeOnBackdropClick: true }}
            styles={{ container: { backgroundColor: 'rgba(0,0,0,0.95)' } }}
            zoom={{
                maxZoomPixelRatio: 3,
                zoomInMultiplier: 2,
                doubleClickMaxStops: 2,
                keyboardMoveDistance: 50,
                wheelZoomDistanceFactor: 100,
            }}
        />
    );
};

export default TalkAttachmentImageViewerModal;
